<list-view *ngIf="listeCompte" [liste]="listeCompte"></list-view>
<floating-button [listeActions]="listeActions" *ngIf="listeActions"></floating-button>